import { Injectable } from '@angular/core';
import { MembershipLevelProcessStateDto } from 'src/app/admin/membership-level-management/membership-level-process-state.dto';
import { ApiService } from '../../shared/api/api.service';
import { MembershipLevelSettingsDto } from './membership-level-settings.dto';
import { MembershipLevel } from './membership-level.model';

@Injectable()
export class MembershipLevelService {
  private _apiService: ApiService;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  public getMembershipLevelName(id: number): Promise<string> {
    let url = `/MembershipLevel/${id}`;

    return this._apiService.get(url).then((data: MembershipLevel) => {
      if (data) return data.Name;
      else return null;
    });
  }

  public getMembershipLevel(id: number): Promise<MembershipLevel> {
    const cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
    return this._apiService.get(`/MembershipLevel/${id}`, cacheOptions);
  }

  getMembershipLevelSetting(): Promise<MembershipLevelSettingsDto> {
    return this._apiService.get(`ConfigSettings/MembershipLevelSetting`);
  }
  public saveMembershipLevelSettings(data: MembershipLevelSettingsDto): Promise<any> {
    return this._apiService.post(`MembershipLevel/MembershipLevelSetting`, data);
  }
  public applyFormulaChanges(data: Array<string>): Promise<any> {
    return this._apiService.post('MembershipLevel/ApplyFormulaChanges', data);
  }
  public getProcessCurrentState(): Promise<Array<MembershipLevelProcessStateDto>> {
    const cacheOptions = this._apiService.getDefaultApiCacheOptionsForNoCache();
    return this._apiService.get('MembershipLevelProcess/CurrentState', cacheOptions);
  }
}
